import { createFileRoute } from "@tanstack/react-router";
import AdminFieldNotes from "@/pages/AdminFieldNotes";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/admin/field-notes/")({
  component: () => (
    <RoleGate allow={['staff']} area="Field Notes"><AdminFieldNotes /></RoleGate>
  ),
});
